module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IB2cksfwAAAEJQTFRFAAAACkiHCUeICUeHCEaHCUeHKF6WRnSlCUaHR3WlwdHh////Zoy0sMrtMHnlH3b/wtLhMHnmZKD/r8ns1eX/GFOP7GIedAAAABZ0Uk5TAIDP/3/Q///A/////////////////3FrlIoAAACJSURBVHicdZDbEsIgDEQDWErYUnr9/181NQhY9bwAZ7JDZonIWNdhHyQM7oaVubtzztRBP46+XAPpyRFCZH2pnFCYmmQgzTnPCeAqF6T8IiG+pQdWlSvgi5R0Lmj+r2zxrUn5aFd5dFLyu6y0iWuyLd9Lx8uHrIWwcl6F/Kzuu+Thqt6EXgWZewJESwplGmgidgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-login-logo.png
// module id = 791
// module chunks = 0